import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface SiteBrevoList {
  id: number;
  site_key: string;
  brevo_list_id: number;
  list_name: string;
  created_at: string;
}

export function useSiteBrevoLists() {
  return useQuery({
    queryKey: ['brevo-site-lists'],
    queryFn: () => apiClient<{ siteKey: string; associations: SiteBrevoList[] }>('/brevo/site-lists'),
  });
}

export function useAssociateSiteList() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ brevoListId, listName }: { brevoListId: number; listName: string }) =>
      apiClient<SiteBrevoList>('/brevo/site-lists', { method: 'POST', body: JSON.stringify({ brevoListId, listName }) }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['brevo-site-lists'] }),
  });
}

export function useDisassociateSiteList() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (brevoListId: number) => apiClient<{ success: boolean }>(`/brevo/site-lists/${brevoListId}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['brevo-site-lists'] }),
  });
}
